"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isArray = function isArray(obj) {
  return Array.isArray(obj);
};

var _default = isArray;
exports["default"] = _default;